import type { Directive } from "vue";

/**
 * v-ripple: onda a partir do ponto tocado (Material state layer).
 *
 * Respeita movimento reduzido (classe `rm` no html, do Perfil, ou
 * prefers-reduced-motion). Força `overflow:hidden` e `position` no host, então
 * não usar em botões que dependem de estourar a borda (ex.: o FAB da nav).
 */

function movimentoDesligado(): boolean {
  if (typeof document === "undefined") return true;
  if (document.documentElement.classList.contains("rm")) return true;
  return window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ?? false;
}

function criarOnda(e: PointerEvent, host: HTMLElement) {
  if (movimentoDesligado()) return;
  const r = host.getBoundingClientRect();
  const tam = Math.max(r.width, r.height);
  const x = (e.clientX || r.left + r.width / 2) - r.left - tam / 2;
  const y = (e.clientY || r.top + r.height / 2) - r.top - tam / 2;
  const onda = document.createElement("span");
  onda.className = "v-ripple-onda";
  onda.style.cssText = `width:${tam}px;height:${tam}px;left:${x}px;top:${y}px`;
  host.appendChild(onda);
  onda.addEventListener("animationend", () => onda.remove(), { once: true });
}

const HANDLER = Symbol("ripple");

export const ripple: Directive<HTMLElement & { [HANDLER]?: (e: PointerEvent) => void }> = {
  mounted(el) {
    if (getComputedStyle(el).position === "static") el.style.position = "relative";
    el.style.overflow = "hidden";
    const h = (e: PointerEvent) => criarOnda(e, el);
    el[HANDLER] = h;
    el.addEventListener("pointerdown", h);
  },
  unmounted(el) {
    const h = el[HANDLER];
    if (h) el.removeEventListener("pointerdown", h);
  },
};
